<script setup lang="ts">
import SlothBlock from "@/components/messages/SlothBlock.vue";
import {SLOTH_TYPE} from "@/entities/enums/SlothType";
import CreatePaymentViewController from "@/targets/light/views/create-payment/ts/CreatePaymentViewController";
import {useI18n} from "vue-i18n";

const viewController = CreatePaymentViewController.of();

const { t } = useI18n({ useScope: 'global' });

const handleReturnToSite = () => {
	viewController.returnToSite();
}
</script>

<template>
	<f7-page
		ref="self"
		class="payment-to-up-complete"
		name="payment-to-up-complete"
		:page-content="false"
	>
		<div class="payment-to-up-complete__content">
			<SlothBlock
				:title="t('payment.toUpComplete.title')"
				:subtitle="t('payment.toUpComplete.subtitle')"
				:type="SLOTH_TYPE.RELAX"
			/>
			<f7-button
				preloader
				class="theme-type"
				@click="handleReturnToSite"
			>
				{{ t('payment.statuses.expired.actions.go-back') }}
			</f7-button>
		</div>
	</f7-page>
</template>

<style lang="scss">
.payment-to-up-complete {
	padding-top: 5rem;
	overflow-y: auto;
	padding-bottom: 32px;

	&__content {
		display: flex;
		flex-direction: column;
		gap: 32px;
		margin: 0 auto;
		max-width: 278px;
	}
}

</style>
